<template>
  <v-form ref="listPolarityForm">
    <v-container>
      <!-- Add Delete Button -->
      <v-col class="text-right">
        <v-btn :to="'polarity/create'" class="primary" small>Add</v-btn>
        <v-btn @click="deactivePolarity" class="ml-2" small color="#eee">
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
        <v-btn @click="$refreshDataTable" class="ml-2" small color="#eee">
          <v-icon small>mdi-refresh</v-icon>
        </v-btn>
      </v-col>
      <!-- Datatable -->
      <datatable
        ref="polarity_datatable"
        :tableOption="tableOption"
        :tableItemSlot="tableItemSlot"
      />
    </v-container>
  </v-form>
</template>
<script>
import datatable from '@/components/datatable.vue'
export default {
  components: {
    datatable
  },
  created () {
  },
  data () {
    return {
      loading: true,
      selected: [],
      dialog: false,
      tableOption: {
        url: 'getPolarityAll',
        editUrl: 'polarity/edit',
        deleteRoute: 'deactivePolarity',
        moduleName: 'polarity',
        headers: [
          { text: 'Actions', value: 'action', sortable: false, align: 'center', width: 80 },
          { text: 'Name', align: 'start', value: 'name' },
          { text: 'Status', value: 'status', align: 'center' },
        ]
      },
      tableItemSlot: {
        status: {
          0: { color: 'green', text: 'Active' },
          1: { color: 'orange', text: 'Inactive' }
        }
      },
    }
  },
  watch: {
    options: {
      handler () {
      },
      deep: true,
    },
  },
  mounted () {
  },
  methods: {
    deactivePolarity () {
      this.$refs.polarity_datatable.massDeleteTableData()
    },
  },
}
</script>
<style lang="css">
.elevation-1 {
  table-layout: flex !important;
}
/* .v-data-table-header > tr > th:first-child{
  background: red;
} */
</style>
